import { useQuery } from 'react-query';
import { Zone } from '../types/types';
import LandscanService from './landscanService';

export const useGetAllZonesPrelim = (fieldId?: number | undefined) => {
  // Convert fieldId to a boolean to check if it's not undefined/null.
  // The query will only run if fieldId is truthy (i.e., not undefined and not null, and not 0).
  // Adjust this check if 0 is a valid ID and should trigger the query.
  const isEnabled = fieldId !== undefined && fieldId !== null;

  return useQuery<Zone[]>(
    ['all-zones-prelim', { fieldId }],
    () => LandscanService.allZonesPrelim(fieldId as number),
    {
      // Only run the query if isEnabled is true
      enabled: isEnabled,
    }
  );
}
